import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { togglePopover } from '../../redux/Slices/popoverSlice';
import {
    setCardCustomFieldValue,
    clearCardCustomFieldValue,
    selectCardCustomFieldValues
} from '../../redux/Slices/customFieldsSlice';
import { showError } from '../../utils/snackbarHelpers';

// Calendar popover for a card's date custom-field. Reads the current value
// from Redux and dispatches commit/clear directly — so the popover system
// doesn't need to carry callbacks in its props.
const CardCustomFieldDate = ({ cardId, fieldId }) => {
    const dispatch = useDispatch();
    const values = useSelector(state => selectCardCustomFieldValues(state, cardId));
    const current = values.find(v => String(v.fieldId) === String(fieldId));
    const date = current?.dateValue ? new Date(current.dateValue) : null;

    const close = () => dispatch(togglePopover({
        contentId: null, position: { top: 0, left: 0 }, targetId: null
    }));

    const handleChange = async (d) => {
        const result = await dispatch(setCardCustomFieldValue({ cardId, fieldId, value: d }));
        if (result.error) showError(dispatch, result.payload || result.error?.message || 'Failed to set date');
        close();
    };

    const handleClear = async () => {
        const result = await dispatch(clearCardCustomFieldValue({ cardId, fieldId }));
        if (result.error) showError(dispatch, result.payload || result.error?.message || 'Failed to clear date');
        close();
    };

    return (
        <div className="cf-date-popover">
            <Calendar value={date || null} onChange={handleChange} />
            {date && (
                <button type="button" className="cf-date-clear-btn" onClick={handleClear}>
                    Clear date
                </button>
            )}
        </div>
    );
};

export default CardCustomFieldDate;
